module.exports = __webpack_public_path__ + "assets/img/user1.78ac0334.jpg";